import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { DocLayout } from "./components/layout/DocLayout";
import { ServerToServer } from "./pages/ServerToServer";
import { GatewayCheckout } from "./pages/GatewayCheckout";
import ScrollToTop from "./components/commons/ScrollToTop";

function App() {
  return (
    <Router>
      <ScrollToTop />
      <DocLayout>
        <Routes>
          <Route path="/" element={<ServerToServer/>} />
          <Route path="/server-to-server/*" element={<ServerToServer />} />
          <Route path="/gateway-checkout/*" element={<GatewayCheckout />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </DocLayout>
    </Router>
  );
}

export default App;
